import { Injectable } from '@angular/core';
import { GenericUtilityService } from '../generic/generic-utility.service';
import { PracticeAndPatientCode } from '../models/intake/intakeAllergies';

@Injectable({
  providedIn: 'root'
})
export class IntakeAllergyService {

  constructor(private genericService: GenericUtilityService) { }

  GetPatientAllergies(PatientAccount: any, PracticeCode: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetPatientAllergies?PracticeCode=" + PracticeCode + '&PatientAccount=' + PatientAccount);
  }

  SavePatientAllergie(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SavePatientAllergie", data);
  }

  GetSolarApiAllergies(data: string, category: string, practiceCode: any) {
    return this.genericService.GenericExternalServiceCallerGet("https://smartsearch.mtbc.com/api/Allergies/GetAllergiesIncludingFreeText?query=" + data + "&practiceCode=" + practiceCode + "&allergyCategory=" + category);
  }

  GetIntakeDropDownList(practiceCode: any, patientAccount: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetIntakeForms_V1?PracticeCode=" + practiceCode + '&PatientAccount=' + patientAccount);
  }

  DeletePatientAllergie(data: any) {
    return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "DeleteAllergy", data);
  }

  SaveIntakeNoknownValues(type: number, patientAccount: any, practiceCode: any) {
    let patInfo = new PracticeAndPatientCode();
    patInfo.patientAccount = patientAccount.toString();
    patInfo.practiceCode = practiceCode.toString();
    if (type == 1) {
      return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SetNoKnownAllergyForPatient", patInfo);
    } else if (type == 2) {
      return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SetNoKnownMedicationForPatient", patInfo);
    } else {
      return this.genericService.ApiPostMethodTalkphr("TalkCheckin", "SetNoKnownFamilyhistoryForPatient", patInfo);
    }
  }

  GetNoKnownHistory(patientAccount: any, practiceCode: any) {
    return this.genericService.ApiGetMethodTalkphr("TalkCheckin/GetNoKnownHistory?PracticeCode=" + practiceCode.toString() + '&PatientAccount=' + patientAccount.toString());
  }

}
